// WFHApprovalModal.jsx
import React, { useEffect, useState } from 'react';
import {
  Modal,
  Button,
  Form,
  Alert,
  Row,
  Col
} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from 'react-toastify';
import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";
const WFHApprovalModal = ({
  show,
  onHide,
  onSubmit,
  employeeName = "John Doe",
  requestDate = "December 15, 2023",
  oldComment = '',
  oldIsApproved =0,
  storedUser=1
}) => {
  const [comment, setComment] = useState(oldComment);
  const [isApproved, setIsApproved] = useState(oldIsApproved);
  const [error, setError] = useState('');

   useEffect(() => {
  if (oldComment !== null && oldComment !== undefined) {
    setComment(oldComment);
  }

  if (oldIsApproved !== null && oldIsApproved !== undefined) {
    setIsApproved(Boolean(oldIsApproved));
  }
}, [oldComment, oldIsApproved]);
  const formatToDDMMYY = (dateString) => {
    if (!dateString) return "N/A";

    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear());

      return `${day}/${month}/${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const handleStatusChange = (approved) => {
    setIsApproved(approved);
    if (error) setError('');
  };


  const handleApproveWFH = async (e) => {
    e.preventDefault();
    try {
      // Update profile data
      const response = await axios.post(`${API_URL}/api/attendance/wfh-approved`, {
        comment: comment,
        isApproved: isApproved,
        name: employeeName,
        date: requestDate
      });
      toast.success("Profile updated successfully");
      onHide();
    }
    catch (err) {
      console.log(err)
      const errorMessage = err.response?.data?.error || "Update failed";
      toast.error(errorMessage);
    }
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className={'bg-success bg-opacity-10'}>
        <Modal.Title className={`fw-bold text-success`}>
          <i className={`bi bi-check-circle-fill me-2`}></i>
          WFH Approval
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Request Details */}
        <div>
          <Row>
            <Col md={6}>
              <div className="mb-2">
                <strong>Employee:</strong> {employeeName}
              </div>
            </Col>
            <Col md={6}>
              <div>
                <strong>Date:</strong> {formatToDDMMYY(requestDate)}
              </div>
            </Col>
          </Row>
        </div>

        {error && (
          <Alert variant="danger" className="mb-3">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            {error}
          </Alert>
        )}

        <Form onSubmit={handleApproveWFH}>
          {/* Status Selection */}
          {/* Status Selection */}
          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              id="approve-checkbox"
              disabled={storedUser.role === 1 || storedUser.name === employeeName}
              label={
                <span className="fw-bold">
                  Approve Request
                </span>
              }
              checked={isApproved}
              onChange={(e) => handleStatusChange(e.target.checked)}
            />
          </Form.Group>


          {/* Comment Section */}
          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">
              Comments
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={comment}
              disabled={storedUser.role === 1 || storedUser.name === employeeName}
              onChange={(e) => setComment(e.target.value)}
              placeholder={"Add optional feedback or instructions..."}
              maxLength={500}
            />
            <Form.Text className="text-muted d-flex justify-content-between">
              <span>{comment.length}/500 characters</span>
            </Form.Text>
          </Form.Group>

          <Modal.Footer className="border-top-0 pt-0">
            <Button
              variant="outline-secondary"
              onClick={onHide}
              className="px-4"
            >
              Cancel
            </Button>
            <Button
              variant={'success'}
              type="submit"
              className="px-4"
              disabled={storedUser.role === 1 || storedUser.name === employeeName}
            >
              <i className={`bi bi-check`}></i>
              Confirm Approval
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default WFHApprovalModal;